import SidebarContext from 'state/SidebarContext';
import { useContext } from 'react';
import ContactButton from './ContactButton';
import SuggestShipping from './SuggestShipping';

const NotOptedIn = () => {
    const { uiText } = useContext(SidebarContext);
    const { suggestShipping } = uiText.sections.sidebar;
    return (
        <>
            <ContactButton />
            {suggestShipping && <SuggestShipping />}
        </>
    );
};

export default NotOptedIn;
